// extracted by mini-css-extract-plugin
export default {"row":"IndividualData_row__97mew"};